<template>
  <div id="contract">
    <Help v-if="showHelp" :help="helpMessage" @close="showHelp = false"></Help>
    <div class="panel" :class="{TA:isTestAchat}">
      <h1>{{ $t('Summary.cart.button') }}</h1>
      <div class="information">
        <ul class="information">
          <!-- two energies with same settings -> we regroup -->
          <li v-if="sameOptions && energies === 'dual'">
            <SvgIcon icon="dual" class="icon"></SvgIcon>
            <span class="tab">
            {{ productDescription }} - {{ $tc(`Offer.Product.card.${labelPriceCDDorCDI(product)}`, product.duration, { n: product.duration }) }}
            <button class="button date main" @click="getRateCard('electricity')">{{$t('Summary.cart.tarifElectricity')}} <SvgIcon class="loading" v-if="loadingRateCart" icon="loading"></SvgIcon></button>
            <button class="button date main" @click="getRateCard('gas')">{{$t('Summary.cart.tarifGas')}} <SvgIcon class="loading" v-if="loadingRateCart" icon="loading"></SvgIcon></button>
          </span>
          </li>
          <!-- one energ or different settings -> two lines -->
          <li v-if="!sameOptions || energies === 'elec'">
            <SvgIcon icon="elec" class="icon"></SvgIcon>
            <span class="tab">
            {{ elecProductDescription }} - {{ $tc(`Offer.Product.card.${labelPriceCDDorCDI(electricityProduct)}`, electricityProduct.duration, { n: electricityProduct.duration }) }}
            <button class="button date main" @click="getRateCard('electricity')">{{$t('Summary.cart.tarifElectricity')}} <SvgIcon class="loading" v-if="loadingRateCart" icon="loading"></SvgIcon></button>
          </span>
          </li>
          <li v-if="!sameOptions || energies === 'gas'">
            <SvgIcon icon="gas" class="icon"></SvgIcon>
            <span class="tab">
            {{ gasProductDescription }} - {{ $tc(`Offer.Product.card.${labelPriceCDDorCDI(gasProduct)}`, gasProduct.duration, { n: gasProduct.duration }) }}
            <button class="button date main" @click="getRateCard('gas')">{{$t('Summary.cart.tarifGas')}} <SvgIcon class="loading" v-if="loadingRateCart" icon="loading"></SvgIcon></button>
          </span>
          </li>
          <li class="desc" v-if="label('label1')">
            <!-- <SvgIcon icon="services-paymentModes" class="icon"></SvgIcon> -->
            <span class="tab">{{ label('label1') }}</span>
          </li>
          <li class="desc" v-if="label('label2')">
            <!-- <SvgIcon icon="services-invoiceModes" class="icon"></SvgIcon> -->
            <span class="tab">{{ label('label2') }}</span>
          </li>
          <li class="desc" v-if="label('label3')">
            <!-- <SvgIcon icon="services-serviceLevels" class="icon"></SvgIcon> -->
            <span class="tab">{{ label('label3') }}</span>
          </li>
          <li class="desc" v-if="label('label4')">
            <span class="tab">{{ label('label4') }}</span>
          </li>
          <li class="desc" v-if="isGasGreen">
            <!-- <SvgIcon icon="gas" class="icon"></SvgIcon> -->
            <span class="tab" v-html="$tc(`Offer.Product.services.green`)"></span>
          </li>
          <li v-if="scenario && (gasDate || elecDate) && scenario !== 'vel' && scenario !== 'watz'">
            <SvgIcon icon="customer-calendar" class="icon"></SvgIcon>
            <span class="tab">{{ $tc(`Summary.cart.deliveryDate.${scenario}`, gasDate && elecDate ? 2 : 1 ,{date: elecDate ? this.$moment(elecDate).format('DD/MM/YYYY') : this.$moment(gasDate).format('DD/MM/YYYY')})}}
          <button class="button date main" @click="$emit('deliverydate')" v-if="!disableDeliveryDate && scenario === 'switch'">{{ $t('Summary.edit') }}</button></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from "vuex";
  import Help from "@/components/Help.vue";
  import productCDDorCDI from "@/mixins/productCDDorCDI";

  export default {
    mixins: [productCDDorCDI],
    data() {
      return {
        loadingRateCart: false,
        showHelp: false,
        helpMessage: null,
      }
    },
    props: {
      disableDeliveryDate: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      ...mapGetters("contract", [
        "hasElec",
        "hasGas",
        "electricityProduct",
        "electricityRate",
        "gasProduct",
        "gasRate",
        "isElectricityMeterOpen",
        "electricityDeliveryDate",
        "electricityOpenMeterDate",
        "electricityMoveDate",
        "isGasMeterOpen",
        "gasDeliveryDate",
        "gasOpenMeterDate",
        "isGasGreen"]),
      ...mapGetters("subscription", ["isTestAchat", "isResidential"]),
      ...mapState("contract", [
        "energies",
        "scenario",
        "address"
      ]),
      elecDate() {
        let elecDate = null;

        if(this.scenario === 'move')
          elecDate = !this.isElectricityMeterOpen ? this.$moment(this.electricityOpenMeterDate, 'DD/MM/YYYY') : null;
        else if (this.electricityDeliveryDate != null)
          elecDate = this.$moment(this.electricityDeliveryDate, 'DD/MM/YYYY');

        return elecDate;
      },
      gasDate() {
        let gasDate = null;

        if(this.scenario === 'move')
          gasDate = !this.isGasMeterOpen ? this.$moment(this.gasOpenMeterDate, 'DD/MM/YYYY') : null;
        else if (this.gasDeliveryDate != null)
          gasDate = this.$moment(this.gasDeliveryDate, 'DD/MM/YYYY');

        return gasDate;
      },
      sameOptions() {
        let products = [];
        if (this.electricityProduct) products.push(this.electricityProduct);
        if (this.gasProduct) products.push(this.gasProduct);

        return this.$store.getters["contract/sameOptions"](products);
      },
      product() {
        return this.hasElec ? this.electricityProduct : this.gasProduct;
      },
      productDescription() {
        return this.product.descriptions[this.$i18n.locale];
      },
      elecProductDescription() {
        return this.electricityProduct.descriptions[this.$i18n.locale];
      },
      gasProductDescription() {
        return this.gasProduct.descriptions[this.$i18n.locale];
      }
    },
    methods: {
      async getRateCard(energy) {
        if (!this.address.locality || typeof this.isResidential !== 'number') {
          this.showHelp = true;
          const labelRequired = {
            address: !!this.address.locality,
            customerType: typeof this.isResidential === 'number'
          };
          const textError = Object.keys(labelRequired).filter(el => labelRequired[el] === false).map((key) => {
              return ` ${this.$t('Offer.Product.card.help.'+key)}`;
          }).join();

          this.helpMessage = {
            title: this.$t('Offer.Product.card.help.title'),
            text: `${this.$t('Offer.Product.card.help.text')} ${textError}`
          };
          return;
        }

        this.loadingRateCart = true;

        try {
          let response = await this.$store.dispatch("contract/getRateCard", energy);
          if(response) {
            this.$router.absoluteUrl(response.url, true);
          }
        } catch(error) {
          console.error(error)
        }

        this.loadingRateCart = false;
      },
      label(labelName) {
        let product = Object.assign({}, this.product);

        let label = "";

        if(product.labels === undefined) {
          product['labels'] = this.$t(`Offer.Product.services.anyProduct.${product.energy}`);
          label = product.labels[labelName];
        } else {
          label = product.labels[labelName][this.$i18n.locale];
        }

        return label.length ? label : null;
      },
    },
    created() {
    },
    components: {
      Help
    }
  };
</script>

<style lang="scss" scoped>
  .help h1 {
    width: 100%;
    box-sizing: border-box;
  }
  .desc {
    &::before {
      content: '-'!important;
    }

    margin-left: 35px!important;
  }

  a {
    color: $black;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .TA {
    .button.date.main {
      background-color: $pink;
      color: $white;
      border-radius: 5px;
    }

    .information {
      ul li {
        /deep/ a {
          color: $pink!important;
          text-decoration: underline $pink!important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/components/Summary/Contract.vue